import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

import App from './App';
import './index.css';
import store, { history } from './store';

import { loginSuccess, logout } from './modules/login/action';
import setupInterceptors from './common/axios-instance/axios-interceptors';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import spacing from '@material-ui/core/styles/spacing';

const token = localStorage.getItem('token');
const clearTime = localStorage.getItem('clearTime');

setupInterceptors(store);

if (token && clearTime && new Date() < new Date(clearTime)) {
  store.dispatch(loginSuccess(token));
} else {
  store.dispatch<any>(logout('/login'));
}

const fontFamily = [
  'Helvetica Neue',
  'Segoe UI',
  'Helvetica',
  'Arial',
  'sans-serif'
].join(',');

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#0C1821',
      contrastText: '#FFF'
    },
    secondary: {
      main: '#0ACA0F',
      contrastText: '#FFF'
    },
    error: {
      main: '#D32F2F'
    },
    contrastThreshold: 3,
    tonalOffset: 0.2
  },
  typography: {
    useNextVariants: true,
    fontFamily,
    fontWeightMedium: 400
  },
  overrides: {
    MuiFormControl: {
      root: {
        marginBottom: spacing.unit
      }
    },
    MuiButton: {
      root: {
        fontFamily
      }
    },
    MuiInput: {
      disabled: {
        color: 'rgb(84, 84, 84)'
      }
    }
  }
});

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>
  </MuiThemeProvider>,
  document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx